/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAccountProfile
 */
export interface GoogleAccountProfile {
    /**
     * Google's unique identifier for the user
     * @type {string}
     * @memberof GoogleAccountProfile
     */
    sub: string;
    /**
     * Full name
     * @type {string}
     * @memberof GoogleAccountProfile
     */
    name: string;
    /**
     * First name
     * @type {string}
     * @memberof GoogleAccountProfile
     */
    givenName: string;
    /**
     * Last name
     * @type {string}
     * @memberof GoogleAccountProfile
     */
    familyName: string;
    /**
     * Email address
     * @type {string}
     * @memberof GoogleAccountProfile
     */
    email: string;
    /**
     * Whether the email is verified
     * @type {boolean}
     * @memberof GoogleAccountProfile
     */
    emailVerified: boolean;
    /**
     * Profile picture URL
     * @type {string}
     * @memberof GoogleAccountProfile
     */
    picture: string;
    /**
     * G Suite domain (hd field)
     * @type {string}
     * @memberof GoogleAccountProfile
     */
    hostedDomain: string;
    /**
     * Token issuer
     * @type {string}
     * @memberof GoogleAccountProfile
     */
    iss: string;
    /**
     * Audience the token is intended for
     * @type {Array<string>}
     * @memberof GoogleAccountProfile
     */
    aud: Array<string>;
    /**
     * Issued at time
     * @type {Date}
     * @memberof GoogleAccountProfile
     */
    iat?: Date;
    /**
     * Expiration time
     * @type {Date}
     * @memberof GoogleAccountProfile
     */
    exp?: Date;
}

/**
 * Check if a given object implements the GoogleAccountProfile interface.
 */
export function instanceOfGoogleAccountProfile(value: object): value is GoogleAccountProfile {
    if (!('sub' in value) || value['sub'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('givenName' in value) || value['givenName'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('emailVerified' in value) || value['emailVerified'] === undefined) return false;
    if (!('picture' in value) || value['picture'] === undefined) return false;
    if (!('hostedDomain' in value) || value['hostedDomain'] === undefined) return false;
    if (!('iss' in value) || value['iss'] === undefined) return false;
    if (!('aud' in value) || value['aud'] === undefined) return false;
    return true;
}

export function GoogleAccountProfileFromJSON(json: any): GoogleAccountProfile {
    return GoogleAccountProfileFromJSONTyped(json, false);
}

export function GoogleAccountProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAccountProfile {
    if (json == null) {
        return json;
    }
    return {
        
        'sub': json['sub'],
        'name': json['name'],
        'givenName': json['givenName'],
        'familyName': json['familyName'],
        'email': json['email'],
        'emailVerified': json['emailVerified'],
        'picture': json['picture'],
        'hostedDomain': json['hostedDomain'],
        'iss': json['iss'],
        'aud': json['aud'],
        'iat': json['iat'] == null ? undefined : (new Date(json['iat'])),
        'exp': json['exp'] == null ? undefined : (new Date(json['exp'])),
    };
}

export function GoogleAccountProfileToJSON(json: any): GoogleAccountProfile {
    return GoogleAccountProfileToJSONTyped(json, false);
}

export function GoogleAccountProfileToJSONTyped(value?: GoogleAccountProfile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sub': value['sub'],
        'name': value['name'],
        'givenName': value['givenName'],
        'familyName': value['familyName'],
        'email': value['email'],
        'emailVerified': value['emailVerified'],
        'picture': value['picture'],
        'hostedDomain': value['hostedDomain'],
        'iss': value['iss'],
        'aud': value['aud'],
        'iat': value['iat'] == null ? value['iat'] : value['iat'].toISOString(),
        'exp': value['exp'] == null ? value['exp'] : value['exp'].toISOString(),
    };
}

